import { SetStateAction, useEffect, useState } from 'react'
import {
  CargoItemInterface,
  CargoUnit,
  SlotItemInterface,
  TransportItemInterface,
} from '../../../types/interfaces'
import { v4 } from 'uuid'
import { CargoTypes } from '../../../types/enums'
import { validNumber } from '../../../utils/constants'

export const useCargoSelector = (
  setTopData: React.Dispatch<
    SetStateAction<TransportItemInterface | CargoItemInterface | SlotItemInterface>
  >,
  setCargoTypeValid: React.Dispatch<SetStateAction<boolean>>,
  topData: TransportItemInterface | CargoItemInterface | SlotItemInterface,
) => {
  const [units, setUnits] = useState<CargoUnit[]>([])
  const [type, setType] = useState<CargoTypes[]>([])
  const [on, setOn] = useState<boolean>(false)
  const [unitsOn, setUnitsOn] = useState<boolean>(false)

  const addUnit = () => {
    setUnits((prev) => [
      ...prev,
      { width: '', height: '', length: '', weight: '', count: '1', uuid: v4() },
    ])
    setTopData((prev) => ({
      ...prev,
      cargo_units: [
        ...prev.cargo_units,
        { width: '', height: '', length: '', weight: '', count: '1', uuid: v4() },
      ],
    }))
  }
  const deleteUnit = (index: number) => {
    setUnits((prev) => {
      const tempData = [...prev]
      setTopData((prev) => ({ ...prev, cargo_units: [...tempData.toSpliced(index, 1)] }))
      return tempData.toSpliced(index, 1)
    })
  }
  const inputHandler = (index: number, value: string, fieldName: string) => {
    if (units[index][fieldName] === '' && value === '0') {
      return
    }
    if (value.length > 5 || (fieldName === 'count' && value.length > 2)) {
      return
    }
    if (validNumber.test(value)) {
      setUnits((prev) => {
        const tempData = [...prev]
        tempData[index][fieldName] = value
        setTopData((prev) => ({ ...prev, cargo_units: [...tempData] }))
        return tempData
      })
    }
  }

  const toggleType = (value: number) => {
    setType((prev) => {
      if (prev.includes(value)) {
        setTopData((prev) => ({
          ...prev,
          cargo_types: [...type.filter((el) => el !== value)],
        }))
        return prev.filter((el) => el !== value)
      }
      setTopData((prev) => ({
        ...prev,
        cargo_types: [...[...type, value]],
      }))
      return [...prev, value]
    })
    //edit
  }

  const unitNotValid = (unit: CargoUnit) => {
    if (
      unit.count === '' ||
      unit.height === '' ||
      unit.weight === '' ||
      unit.width === '' ||
      unit.length === ''
    )
      return true
    return false
  }

  const setUnitPattern = (el: CargoUnit, index: number, pattern: CargoUnit) => {
    setUnits((prev) => {
      const tempData = [...prev]
      tempData[index] = {
        ...tempData[index],
        width: pattern.width,
        height: pattern.height,
        length: pattern.length,
      }
      setTopData((prev) => ({ ...prev, cargo_units: [...tempData] }))
      return tempData
    })
  }

  useEffect(() => {
    setCargoTypeValid(
      units.filter(
        (el) =>
          el.count === '' ||
          el.height === '' ||
          el.weight === '' ||
          el.width === '' ||
          el.length === '',
      ).length === 0,
    )
  }, [units, setCargoTypeValid])

  useEffect(() => {
    if (!on) {
      setType([])
      setTopData((prev) => ({ ...prev, cargo_types: [] }))
      setUnitsOn(false)
    }
  }, [on, setTopData])

  useEffect(() => {
    if (unitsOn && topData.cargo_units.length === 0) {
      setUnits([{ width: '', height: '', length: '', weight: '', count: '1', uuid: v4() }])
    } else if (unitsOn && topData.cargo_units.length > 0) {
      setUnits(topData.cargo_units)
    } else {
      setUnits([])
    }
    setTopData((prev) => ({ ...prev, cargo_units: [] }))
  }, [unitsOn, setTopData])

  useEffect(() => {
    if (topData.cargo_types.length > 0 || topData.cargo_units.length > 0) {
      setOn(true)
      if (topData.cargo_units.length > 0) {
        setUnitsOn(true)
      }
      if (topData.cargo_types.length > 0) {
        setType(topData.cargo_types)
      }
    }
  }, [topData])

  return {
    units,
    addUnit,
    toggleType,
    type,
    on,
    setOn,
    unitsOn,
    setUnitsOn,
    deleteUnit,
    inputHandler,
    unitNotValid,
    setUnitPattern,
  }
}
